'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'bug';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f188';
var svgPathData = ['M160 208l0 144c0 65.3 48.9 119.1 112 127l0-223 32 0 0 223c63.1-7.9 112-61.7 112-127l0-144-256 0zM224 96l128 0c0-35.3-28.7-64-64-64s-64 28.7-64 64z', 'M288 32c35.3 0 64 28.7 64 64L224 96c0-35.3 28.7-64 64-64zM192 96l0 32 192 0 0-32c0-53-43-96-96-96s-96 43-96 96zM416 352c0 65.3-48.9 119.1-112 127l0-223-32 0 0 223c-63.1-7.9-112-61.7-112-127l0-144 256 0 0 144zm32 0l0-48 128 0 0-32-128 0 0-80 89.6-67.2 12.8-9.6-19.2-25.6-12.8 9.6-102.4 76.8-256 0-102.4-76.8-12.8-9.6-19.2 25.6 12.8 9.6 89.6 67.2 0 80-128 0 0 32 128 0 0 48c0 10.2 1 20.2 2.8 29.9l-92.4 69.3-12.8 9.6 19.2 25.6 12.8-9.6 83.1-62.3C165 471.8 221.8 512 288 512s123-40.2 147.3-97.5l83.1 62.3 12.8 9.6 19.2-25.6-12.8-9.6-92.4-69.3c1.8-9.7 2.8-19.7 2.8-29.9z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBug = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;